import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const ButtonsWrapper: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        [`& > .${buttonClassName}`]: {
            // marginLeft: pxToRem(8),
        },
    },
});

export const SocialMediaIcons: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        [`& > button`]: {
            marginRight: pxToRem(10),
            [`& .${svgIconClassName}`]: {
                width: pxToRem(28),
                height: pxToRem(28),
            },
        },
    },
});

export const CopyLink: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        marginTop: pxToRem(23),
        cursor: 'pointer',
        '> div:first-child': {
            width: pxToRem(30),
            marginTop: pxToRem(-1),
            paddingLeft: pxToRem(2),
            [`& .${svgIconClassName}`]: {
                width: pxToRem(20),
                height: pxToRem(20),
            },
        },
    },
});
